import type { IconSvgObject } from './types';

const LineSquiggleIcon: IconSvgObject = [
  ["path", { d: "M11.254 3C3.69537 4.38462 -1.46419 15.9844 8.53996 14C18.6227 12 19.5495 6.17775 17.1107 5C12.8099 2.92308 2.13632 14.193 10.9824 17.5385C20.1355 21 22.509 14.5768 20.1355 13.5C17.9313 12.5 11.8028 17 17.9313 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default LineSquiggleIcon;
